<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="85"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <flowView v-if="showFlowView"
                  :formData="formData"
                  :spInfo="spInfo"
                  :flowInfo="flowInfo"
                  :loading="dialogLoading"
                  @closeDialog="closeDialog">
        </flowView>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import flowView from "@/components/flow/flowInfo/view"

    export default {
        name: 'runTask',
        props: ['menuData'],
        components: {
            tableGrid,
            toolBar,
            flowView
        },
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "流程名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                showFlowView:false,
                spInfo:{},
                flowInfo:{},
                flowTypeList:this.$store.state.flowTypeList,

                formData: {},
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showDelegate: false,
                dialogLoading: false,

                headList: [
                    {
                        column_name: '_px',
                        column_comment: '序号',
                        column_width: '55'
                    },
                    {
                        column_name: 'PNAME_',
                        column_comment: '流程名称',
                        column_width: '150'
                    },
                    {
                        column_name: 'INITATOR',
                        column_comment: '申请人',
                        column_width: '100',
                    },
                    {
                        column_name: 'ASSIGNEE_',
                        column_comment: '办理人或岗位',
                        column_width: '120',
                    },
                    {
                        column_name: 'NAME_',
                        column_comment: '任务节点',
                        column_width: '150',
                    },
                    {
                        column_name: 'START_TIME_',
                        column_comment: '开始时间',
                        column_width: '150'
                    },
                    {
                        column_name: 'END_TIME_',
                        column_comment: '结束时间',
                        column_width: '150'
                    },
                    {
                        column_name: 'ZTIME',
                        column_comment: '用时',
                        column_width: '150',
                    },
                    {
                        column_name: "_opt", column_comment: "操作", opts: [
                            {method: "info", name: "流程信息", type: "primary", icon: "el-icon-toilet-paper"},
                        ]
                    },
                ],
            }
        },
        mounted() {
            this.getListData() // 初始化表格数据
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/hitask/list",
                    param: {
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
            },
            async tableOpt(type, data) {
                this.formData = data;
                let str = data.PROC_DEF_ID_.split(":");
                this.flowInfo = {};
                this.flowTypeList.forEach(item=>{
                    if(item.dictionaryCode == str[0]){
                        this.flowInfo = {
                            billType:item.billType,
                            model_key:item.dictionaryCode,
                            billTypeCN:item.dictionaryName,
                            linkUrl:item.linkUrl,
                        }
                        return false;
                    }
                })
                if(JSON.stringify(this.flowInfo) === '{}'){
                    this.$message({message: '找不到对应的流程配置', type: 'error'});
                    return;
                }

                if(type==="info"){
                    let param = {
                        url: "/"+this.flowInfo.linkUrl+"/view",
                        param: {
                            PROC_INST_ID_:this.formData.PROC_INST_ID_,
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if(data.infoCode == "0"){
                        this.spInfo = data.data;
                        this.showFlowView = true;
                    }
                    //  this.$message.info("开发中...")
                }
            },
            closeDialog() {
                this.showFlowView = false;
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }
    }
</style>